import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

const PartnerThankYouPage = () => {
  return (
    <div className="pt-32 pb-24 min-h-[70vh] flex items-center" data-testid="partner-thank-you-page">
      <div className="chaleur-container max-w-2xl text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 border border-foreground rounded-full mb-8 animate-fade-in-up">
          <Check className="w-6 h-6" strokeWidth={1.5} />
        </div>
        <p className="text-xs tracking-[0.3em] uppercase text-muted-foreground mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          Application received
        </p>
        <h1 className="editorial-italic text-4xl md:text-5xl lg:text-6xl leading-tight mb-8 animate-fade-in-up" style={{ animationDelay: '0.15s' }}>
          Thank you.<br /> We&apos;ll be in touch.
        </h1>
        <p className="text-base md:text-lg text-muted-foreground leading-relaxed max-w-lg mx-auto mb-4 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          Our partner desk personally reviews every enterprise. If your craft story fits our
          current intake, expect a note from us within three working days.
        </p>
        <p className="text-sm text-muted-foreground mb-12 animate-fade-in-up" style={{ animationDelay: '0.25s' }}>
          A confirmation copy is on its way to your inbox.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          <Link
            to="/"
            className="inline-flex items-center justify-center px-8 py-3 border border-foreground text-sm tracking-widest uppercase hover:bg-foreground hover:text-background transition-colors"
            data-testid="thank-you-home-link"
          >
            Return home
          </Link>
          <Link
            to="/shop"
            className="inline-flex items-center justify-center px-8 py-3 bg-foreground text-background text-sm tracking-widest uppercase hover:opacity-90 transition-opacity"
            data-testid="thank-you-shop-link"
          >
            Explore the collection
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PartnerThankYouPage;
